import http from '@/utils/http';

export default {
	// 查询任务进度（V3 通用）
	getProgress: data => {
		return http({ url: '/api/admin/v3/progress/getProgress', data }).then(r => r);
	},
};
